import { ItemsCountCell } from "app/pages/sales-intelligence/common-components/table-cells/components/ItemsCountCell/ItemsCountCell";
import type { LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search";
import { COLUMN_INTENT_SIGNAL_NAME } from "app/pages/sales-intelligence/sub-modules/signals/constants";
import { StyledCenteredBaseCell } from "app/pages/sales-intelligence/sub-modules/signals/containers/cells/SignalIntentCellContainer/styles";
import { useSignalTooltipDelayed } from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useSignalTooltipDelayed";
import type {
    IUseTrackedSignalTooltipResponse } from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import {
    useTrackedSignalTooltip,
} from "app/pages/sales-intelligence/sub-modules/signals/hooks/cells/useTrackedSignalTooltip";
import useTooltipDelayedState from "app/pages/sales-intelligence/sub-modules/signals/hooks/signals-tooltip/useTooltipDelayedState";
import { getCompanyOverviewLink } from "app/pages/sales-intelligence/sub-modules/signals/utils/signalCompanyOverviewLink";

import { SignalIntentTooltipContainer } from "../SignalIntentTooltipContainer/SignalIntentTooltipContainer";

interface ISignalIntentCellContainerProps<V extends LeadsSearchRow> {
    record: V;
}

export const SignalIntentCellContainer = <V extends LeadsSearchRow>({ record }: ISignalIntentCellContainerProps<V>) => {
    const intentTopics = record[COLUMN_INTENT_SIGNAL_NAME] ?? [];
    const { redirectLink, getSignalTypeLink } = getCompanyOverviewLink({ record });
    const { onTrackedTooltipClick, onTrackedTooltipOpen }: IUseTrackedSignalTooltipResponse = useTrackedSignalTooltip({
        field: COLUMN_INTENT_SIGNAL_NAME,
        value: intentTopics.length,
    });
    const tooltipDelayedState = useTooltipDelayedState();
    const { onMouseLeave, onMouseEnter } = useSignalTooltipDelayed({
        onTooltipOpen: onTrackedTooltipOpen,
        tooltipDelayedState,
    });

    return (
        <SignalIntentTooltipContainer
            row={record}
            getSignalTypeLink={getSignalTypeLink}
            redirectLink={redirectLink}
            onViewAll={onTrackedTooltipClick}
        >
            <StyledCenteredBaseCell>
                <ItemsCountCell
                    value={intentTopics.length}
                    onMouseLeave={onMouseLeave}
                    onMouseEnter={onMouseEnter}
                />
            </StyledCenteredBaseCell>
        </SignalIntentTooltipContainer>
    );
};
